import { useHead } from '#app';
import headLinks from '@/utils/seo/headLinks';
import { usePageDataStore } from '@/stores/pageDataStore';

export const useDiscoHead = () => {
  const store = usePageDataStore();

  const { searchTerm } = store.pageData.meta?.context || {};

  const script = [];

  if (searchTerm && searchTerm.length) {
    const context = store.pageData.meta?.context || {};

    const searchContext = ['originalSearchTerm', 'searchTerm', 'navigationType'].reduce((acc, key) => {
      if (typeof context[key] === 'string') {
        acc[key] = context[key];
      }

      return acc;
    }, {});

    const innerHTML = `window.__PLP_SEARCH_CONTEXT__ = ${JSON.stringify(searchContext)}`;
    script.push({
      innerHTML,
      type: 'text/javascript',
    });
  }

  useHead({
    script,
    link: headLinks(),
  });
};
